import Cookies from 'universal-cookie';
import imageSign from '../images/default-signature-background-2.png'
import pdfReference from '../pdf-referencia.pdf'
import imageColaboradorApariencia from '../images/firmaColaborador.png'
import axios from "axios";
import { logout } from "../components/login/SesionService";
import {ReactComponent as AllInbox} from "../assets/images/icons/all_inbox.svg"
import {ReactComponent as DinamicFeed} from "../assets/images/icons/dynamic_feed.svg"
import {ReactComponent as HowToVote} from "../assets/images/icons/how_to_vote.svg"
import {ReactComponent as HistoryEdu} from "../assets/images/icons/history_edu.svg"
import {ReactComponent as CancelPresentation} from "../assets/images/icons/cancel_presentation.svg"
import {ReactComponent as Verified} from "../assets/images/icons/verified.svg"
import {ReactComponent as OpenBrowser} from "../assets/images/icons/open_in_browser.svg"
import {ReactComponent as Publish} from "../assets/images/icons/publish.svg"
import {ReactComponent as TaskAlt} from "../assets/images/icons/task_alt.svg"

const cookies = new Cookies();

export const URL = window.location.origin+"/mirecibo/";
// export const URL = "http://localhost:8090"+"/mirecibo/";

export const iscertLoguin = false;
export const aparienciaFirma = true;
export const aparienciaFirmaUsuario = true;

export const PDF = 2;
export const XML = 1;
export const loteNuevo = "01";
export const loteFirmado = "02";
export const lotePublicar = "03";
export const lotePublicado = "04";
export const loteCerrado = "05";

export const reciboPendiente = "01";
export const reciboConfirmados = "02";
export const reciboFirmados = "03";
export const reciboRechazados = "04"

export const reportePendientes = "01"
export const resporteConfirmado = "02"
export const reporteFirmado = "03"
export const reporteRechazado = "04"


/*--------Roles---------------*/
export const administradorEmpresas = "01";
export const empleado = "02";
export const auditor = "03";
export const gestorEmpresa = "04";
export const firmaRRHH = "06";
export const firmaRL = "05";
export const reportes = "07"
export const estructuraOrganizacional = "08"
export const gestionTramites = "09"
export const gestionNotificacion = "10"
export const gestionLegajos = "11"
export const verNotificaciones = "12"
/*--------FinRoles---------------*/


export const timeoutMilisegundos = 80000;

export const firmaColaboradorRechazar = "01"
export const firmaColaborador = "02"
export const aceptar = "03"
export const aceptarRechazar = "04"

export const logoutURL = URL + 'usuario/keycloak/logout'
export const refreshTokenURL = URL + 'usuario/keycloak/refreshToken'

export const idEmpresa = () => cookies.get("empresa");
export const nombreEmpresa = () => cookies.get("nombreEmpresa");
export const username = () => cookies.get("username");
export const logueado = () => (cookies.get('logged') == "true");
export const admin = () => (cookies.get('admin') == "true");


/*------Mostrar Contraseña------*/
export const mostrarModificarContrasenha = true;


export const getAuthorizationHeader = () => {
  return {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true
}
}

export const getAuthorizationHeaderUpload = () => {
  return {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    withCredentials: true
  }
}



export const getEstadoURL = () => {
  if (window.location.href.indexOf("nuevos") > -1) {
    return loteNuevo;
  }
  if (window.location.href.indexOf("firmados") > -1) {
    return loteFirmado;
  }
  if (window.location.href.indexOf("publicar") > -1) {
    return lotePublicar;
  }
  if (window.location.href.indexOf("publicados") > -1) {
    return lotePublicado;
  }
  if (window.location.href.indexOf("cerrados") > -1) {
    return loteCerrado;
  }
}

export const getEstadoURLReporte = () => {
  if (window.location.href.indexOf("pendientes") > -1) {
    return reportePendientes;
  }
  if (window.location.href.indexOf("aceptados") > -1) {
    return resporteConfirmado;
  }
  if (window.location.href.indexOf("firmados") > -1) {
    return reporteFirmado;
  }
  if (window.location.href.indexOf("rechazados") > -1) {
    return reporteRechazado;
  }
}
export const getEstadoReciboURL = () => {
  if (window.location.href.indexOf("pendientes") > -1) {
    return reciboPendiente;
  }
  if (window.location.href.indexOf("confirmados") > -1) {
    return reciboConfirmados;
  }
  if (window.location.href.indexOf("firmados") > -1) {
    return reciboFirmados;
  }
  if (window.location.href.indexOf("rechazados") > -1) {
    return reciboRechazados;
  }
}

export const verificarRol = (rolData, rolAsignado) => {
  let mostarVista = false;

  if (rolAsignado == undefined)
    return false

  if (rolAsignado == "admin")
    return true;

  if (rolData != null && rolData.roles != null) {
    rolData.roles.map(function (rol) {
      if (rolAsignado.includes(rol.codigo)) {
        mostarVista = true;
      }
    })
  }
  return mostarVista;
}
export const urlImageSign = imageSign
export const pdfReferencia = pdfReference
export const firmaColaboradorApariencia = imageColaboradorApariencia

export const breadcrumBandeja = [
  {
    nombre: 'Pendientes',
    url: '/bandeja/pendientes',
    rol: [empleado],
    icon: <div className="icon"> <span className="material-symbols-outlined"> dynamic_feed </span> </div>
  },
  {
    nombre: 'Confirmados',
    url: '/bandeja/confirmados',
    rol: [empleado],
    icon: <div className="icon"> <span className="material-symbols-outlined"> how_to_vote </span> </div>
  },
  {
    nombre: 'Firmados',
    url: '/bandeja/firmados',
    rol: [empleado],
    icon: <div className="icon"> <span className="material-symbols-outlined"> history_edu </span> </div>
  },
  {
    nombre: 'Rechazados',
    url: '/bandeja/rechazados',
    rol: [empleado],
    icon: <div className="icon"> <span className="material-symbols-outlined"> cancel_presentation </span> </div>
  }
]

export const breadcrumLotes = [
  {
    nombre: 'Nuevos',
    url: '/lote/nuevos',
    rol: [gestorEmpresa, administradorEmpresas, firmaRRHH],
    icon: <div className="icon"> <span className="material-symbols-outlined"> new_releases </span> </div>
  },
  {
    nombre: 'Firmados',
    url: '/lote/firmados',
    rol: [gestorEmpresa, administradorEmpresas, firmaRL],
    icon: <div className="icon"> <span className="material-symbols-outlined"> history_edu </span> </div>
  },
  {
    nombre: 'Para publicar',
    url: '/lote/publicar',
    rol: [gestorEmpresa, administradorEmpresas],
    icon:<div className="icon"> <span className="material-symbols-outlined"> open_in_browser </span> </div>
  },
  {
    nombre: 'Publicados',
    url: '/lote/publicados',
    rol: [gestorEmpresa, administradorEmpresas],
    icon: <div className="icon"> <span className="material-symbols-outlined"> publish </span> </div>
  },
  {
    nombre: 'Cerrados',
    url: '/lote/cerrados',
    rol: [gestorEmpresa, administradorEmpresas],
    icon: <div className="icon"> <span className="material-symbols-outlined"> task_alt </span> </div>
  }

]

export const breadcrumConfig = [
  {
    nombre: 'Tipos de documentos',
    url: '/configuracion/tipo-documento',
    rol: [gestorEmpresa, firmaRRHH]
  },
  {
    nombre: 'Tipos de tramites',
    url: '/configuracion/tipo-tramite',
    rol: [gestorEmpresa, gestionTramites]
  },
  {
    nombre: 'Aplicaciones Externas',
    url: '/configuracion/aplicaciones-externas',
    rol: [gestorEmpresa, firmaRRHH]
  },
  {
    nombre: 'Numero MTESS Patronal',
    url: '/configuracion/numero-patronal',
    rol: [gestorEmpresa, firmaRRHH]
  },
  {
    nombre: 'Plantillas de Correo',
    url: '/configuracion/plantilla-correo',
    rol: [gestorEmpresa]
  },
    {
    nombre: 'Feriados',
    url: '/configuracion/feriados',
    rol: [gestorEmpresa]
  },
]

export const breadcrumEstructura = [
  {
    nombre: 'Estructura Organizacional',
    url: '/estructura/organizacion',
    rol: [estructuraOrganizacional]
  },
]

export const breadcrumLegajos = [
  {
    nombre: 'Legajos',
    url: '/administracion/legajos',
    rol: [gestionLegajos]
  },
]

export const breadcrumTramites = [
  {
    nombre: 'Tramites Pendientes',
    url: '/tramites/pendientes',
    rol: [gestionTramites]
  },
  {
    nombre: 'Tramites Firmados',
    url: '/tramites/firmados',
    rol: [gestionTramites]
  },
  {
    nombre: 'Tramites Cerrados',
    url: '/tramites/cerrados',
    rol: [gestionTramites]
  },
  {
    nombre: 'Tramites Rechazados',
    url: '/tramites/rechazados',
    rol: [gestionTramites]
  }
]

export const breadcrumAdmin = () => {
  let items
  !admin() ?
    items = [{ nombre: 'Usuarios', url:  '/administracion/usuarios', rol: [administradorEmpresas, gestorEmpresa, firmaRRHH] },
    { nombre: "Grupos de usuarios", url: '/administracion/grupos', rol: [administradorEmpresas, gestorEmpresa, firmaRRHH] },
    { nombre: "Legajos", url: '/administracion/legajos', rol: [gestionLegajos] }]
    :
    items = [{ nombre: 'Usuarios', url: '/admin/usuarios', rol: ['admin'] }, 
    { nombre: 'Empresas', url: '/admin/empresas', rol: ['admin'] },
    { nombre: 'Tipos de documentos', url: '/configuracion/tipo-documento', rol: ['admin'] }, 
    { nombre: 'Tipos de tramites', url: '/configuracion/tipo-tramite', rol: ['admin'] }, 
    { nombre: 'Proveedores de firma', url: '/admin/proveedores-firma', rol: ['admin'] },
    { nombre: 'Configuracion de Correo', url: '/notificacion/configuracion-correo', rol: ['admin'] },
    { nombre: 'Aplicaciones externas', url: '/admin/configuracion/aplicaciones-externas', rol: ['admin'] }
  ]
  return items;
}

export const breadcrumReportes = [
  {
    nombre: 'Todos',
    url: '/reporte/recibo-colaborador/todos',
    rol: [gestorEmpresa,reportes],
    icon: <div className="icon"> <span className="material-symbols-outlined"> all_inbox </span> </div>
  },
  {
    nombre: 'Pendientes',
    url: '/reporte/recibo-colaborador/pendientes',
    rol: [gestorEmpresa,reportes],
    icon: <div className="icon"> <span className="material-symbols-outlined"> hourglass_empty </span> </div>
  },
  {
    nombre: 'Firmados',
    url: '/reporte/recibo-colaborador/firmados',
    rol: [gestorEmpresa,reportes],
    icon: <div className="icon"> <span className="material-symbols-outlined"> history_edu </span> </div>
  },
  {
    nombre: 'Rechazados',
    url: '/reporte/recibo-colaborador/rechazados',
    rol: [gestorEmpresa,reportes],
    icon: <div className="icon"> <span className="material-symbols-outlined"> cancel_presentation </span> </div>
  },
  {
    nombre: 'Confirmados',
    url: '/reporte/recibo-colaborador/aceptados',
    rol: [gestorEmpresa,reportes],
    icon: <div className="icon"> <span className="material-symbols-outlined"> task_alt </span> </div>
  }
]

export const breadcrumMisNotificaciones = [
  {
    nombre: 'Todos',
    url: '/notificaciones/todos',
    rol: [verNotificaciones],
     icon: <div className="icon"> <span className="material-symbols-outlined"> all_inbox </span> </div>
  },
  {
    nombre: 'Leidas',
    url: '/notificaciones/leidas',
    rol: [verNotificaciones],
     icon: <div className="icon"> <span className="material-symbols-outlined"> drafts </span> </div>
  },
  {
    nombre: 'No Leidas',
    url: '/notificaciones/noleidas',
    rol: [verNotificaciones],
     icon: <div className="icon"> <span className="material-symbols-outlined"> mark_email_unread </span> </div>
  },
    {
    nombre: 'Enviadas',
    url: '/notificaciones/emitidas',
    rol: [gestionNotificacion],
    icon: <div className="icon"> <span className="material-symbols-outlined"> send </span> </div>
  },
  {
    nombre: 'Borradores',
    url: '/notificaciones/borradores',
    rol: [gestionNotificacion],
    icon: <div className="icon"> <span className="material-symbols-outlined"> insert_drive_file </span> </div>
  },
]


export const iscert = () => {
  axios.get(URL + "auth/1").then((res) => {
    window.location.replace(res.data);
  }, error => {
    if (error.response.status === 401) {
      logout();
    }
    return error;
  });
}

export const EFIRMA = "01";
export const IScert = "02";
export const TUID = "03";

export const psa = [
  {
    codigo: "01",
    nombre: "EFIRMA"
  },
  {
    codigo: "02",
    nombre: "IScert"
  },
  {
    codigo: "03",
    nombre: "TuID"
  }
]

export const codigoTramitePendiente = "01";
export const codigoTramiteFirmado = "02"
export const codigoTramiteCerrado = "03"
export const codigoTramiteRechazado = "04"

export const codigoFormularioReposoMedico = '3'
export const codigoFormularioAdelanto = '2'
export const codigoFormularioVacaciones = '1'

export const getNombreSeccion = (url) => {
  // Rutas específicas primero (más largas tienen prioridad)
  if (url.includes('administracion/legajo')) return 'Legajos';

  const seccion = url.split('/').find(part =>
      ['lote', 'bandeja', 'configuracion', 'estructura', 'administracion', 'reporte', 'tramites','notificaciones'].includes(part)
  );
  switch (seccion) {
      case 'lote': return 'Lotes';
      case 'bandeja': return 'Bandeja';
      case 'configuracion': return 'Configuración';
      case 'estructura': return 'Estructura';
      case 'administracion': return 'Administración';
      case 'reporte': return 'Reportes';
      case 'tramites': return 'Trámites';
      case 'notificaciones': return 'Notificaciones';
      default: return null;
  }
}